"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertTrue = exports.getOrThrow = exports.isNotNullOrUndefined = exports.isNullOrUndefined = void 0;
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
exports.isNullOrUndefined = isNullOrUndefined;
function isNotNullOrUndefined(value) {
    return !isNullOrUndefined(value);
}
exports.isNotNullOrUndefined = isNotNullOrUndefined;
function getOrThrow(value, errorMessage = 'Unexpected missing value') {
    if (isNullOrUndefined(value)) {
        throw new Error(errorMessage);
    }
    return value;
}
exports.getOrThrow = getOrThrow;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function assertTrue(value, errorMessage = 'Assertion failed') {
    if (!Boolean(value)) {
        throw new Error(errorMessage);
    }
}
exports.assertTrue = assertTrue;
//# sourceMappingURL=types.js.map